import React from 'react';
import '../static/chatroom.css'; // Optional: link your styles here

const LastNotes = () => {
  return (
    <main className="content">
      <div className="container p-0">
        <h1 className="h3 mb-3">Messages</h1>

        <div className="card">
          <div className="row g-0">
            <div className="col-12 col-lg-5 col-xl-3 border-right">
              <div className="px-4 d-none d-md-block">
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <input type="text" className="form-control my-3" placeholder="Search..." />
                  </div>
                </div>
              </div>

              {[
                {
                  name: 'Vanessa Tucker',
                  img: 'https://bootdey.com/img/Content/avatar/avatar5.png',
                  status: 'Online',
                  badge: 5,
                },
                {
                  name: 'William Harris',
                  img: 'https://bootdey.com/img/Content/avatar/avatar2.png',
                  status: 'Online',
                  badge: 2,
                },
                {
                  name: 'Sharon Lessman',
                  img: 'https://bootdey.com/img/Content/avatar/avatar3.png',
                  status: 'Online',
                },
                {
                  name: 'Jennifer Chang',
                  img: 'https://bootdey.com/img/Content/avatar/avatar3.png',
                  status: 'Offline',
                },
              ].map((user, idx) => (
                <a href="#" className="list-group-item list-group-item-action border-0" key={idx}>
                  {user.badge && <div className="badge bg-success float-right">{user.badge}</div>}
                  <div className="d-flex align-items-start">
                    <img src={user.img} className="rounded-circle mr-1" alt={user.name} width="40" height="40" />
                    <div className="flex-grow-1 ml-3">
                      {user.name}
                      <div className="small">
                        <span className={`fas fa-circle ${user.status === 'Online' ? 'chat-online' : 'chat-offline'}`}></span> {user.status}
                      </div>
                    </div>
                  </div>
                </a>
              ))}

              <hr className="d-block d-lg-none mt-1 mb-0" />
            </div>

            <div className="col-12 col-lg-7 col-xl-9">
              <div className="py-2 px-4 border-bottom d-none d-lg-block">
                <div className="d-flex align-items-center py-1">
                  <div className="position-relative">
                    <img src="https://bootdey.com/img/Content/avatar/avatar3.png" className="rounded-circle mr-1" alt="Sharon Lessman" width="40" height="40" />
                  </div>
                  <div className="flex-grow-1 pl-3">
                    <strong>Sharon Lessman</strong>
                    <div className="text-muted small"><em>Typing...</em></div>
                  </div>
                  <div>
                    <button className="btn btn-primary btn-lg mr-1 px-3">
                      <i className="feather feather-phone feather-lg" />
                    </button>
                    <button className="btn btn-info btn-lg mr-1 px-3 d-none d-md-inline-block">
                      <i className="feather feather-video feather-lg" />
                    </button>
                    <button className="btn btn-light border btn-lg px-3">
                      <i className="feather feather-more-horizontal feather-lg" />
                    </button>
                  </div>
                </div>
              </div>

              <div className="position-relative">
                <div className="chat-messages p-4">
                  {/* Add your messages content here as per the same pattern. You can map them like user list above */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default LastNotes;
